import { useEffect, useState } from 'react';

import useBranding from 'store/branding';

const useDynamicManifest = (): { generated: boolean } => {
  const [brandingState] = useBranding();
  const { settings } = brandingState;
  const [generated, setGenerated] = useState(false);

  useEffect(() => {
    if (settings && settings.favicon && settings.title && !generated) {
      const partnerManifest = {
        start_url: window.location.origin,
        display: 'standalone',
        short_name: settings.title,
        name: settings.title,
        icons: [
          {
            src: settings.favicon,
            sizes: '64x64 32x32 24x24 16x16',
            type: 'image/x-icon',
          },
          {
            src: settings.favicon,
            type: 'image/png',
            sizes: '192x192',
          },
          {
            src: settings.favicon,
            type: 'image/png',
            sizes: '512x512',
          },
        ],
        theme_color: settings.actionColor || '#000000',
        background_color: settings.bgColor || '#ffffff',
      };
      const blob = new Blob([JSON.stringify(partnerManifest)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      let manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
      if (!manifestLink) {
        manifestLink = document.createElement('link');
        manifestLink.rel = 'manifest';
        document.head.appendChild(manifestLink);
      }
      manifestLink.href = url;
      setGenerated(true);
    }
  }, [settings, generated]);

  return { generated };
};

export default useDynamicManifest;
